import { Options } from '@sheerid/jslib';
import { messagesEN } from './lib/intl/en-US';
import { RecursivePartial } from './lib/types/types';


export const programId = '624db8964c7d9533711029af';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        'en-GB': {},
        de: {},
        fr: {},
        ar: {},
        el: {},
        es: {},
        iw: {},
        ja: {},
        ms: {},
        no: {},
        zh: {},
    },
};
